import script from "./ticket-details-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./ticket-details-modal.vue?vue&type=script&setup=true&lang=js"

import "./ticket-details-modal.vue?vue&type=style&index=0&id=1a323aff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a323aff"]])

export default __exports__